"use client";

import {useSession} from "next-auth/react";
import {Puff} from "react-loader-spinner";
import {useEffect, useState} from "react";
import axios from "@/lib/axios";
import ButtonPayment from "@/components/Payments/ButtonPayment";

export default function BuyTicket({eventId, redirectModule = "opentraining"}){
    const session = useSession();
    const [load, setLoad] = useState(true);
    const [products, setProducts] = useState(false);
    const [paymentId, setPaymentId] = useState('');

    useEffect(() => {
        if(session.status === "authenticated" && !products){
            axios.get('products', {
                headers : {
                    Authorization : `Bearer ${session.data.user.token}`
                }
            }).then(res => {
                setProducts(res.data.data)
                setLoad(false);
            })
        }
    }, [products]);

    if(load){
        return(
            <div className={"flex justify-center"}>
                <Puff
                    visible={true}
                    height={100}
                    width={100}
                    color={"#F0A202"}
                />
            </div>
        )
    }else{
        return(
            <div className={"flex flex-col md:flex-row items-center justify-center gap-2"}>
                <select className={"rounded"} onChange={e => setPaymentId(e.target.value)}>
                    <option disabled selected>Choisissez votre formule</option>
                    {products.map(function(product){
                       return (<option key={product.id} value={product.id_price}>{product.denomination} - {product.price}€</option>)
                    })}
                </select>
                {paymentId &&(
                    <ButtonPayment product={paymentId} type={"OPT"} name={"Acheter"} redirect_id={eventId} redirect_module={redirectModule}/>
                )}

            </div>
        )
    }

}